export enum EKYC_STAGE {
  Rejected = 'Rejected',
  PendingReview = 'Pending review',
  PendingUserInput = 'Pending user input',
  Done = 'Done'
}
